import React from 'react';

const Mastercard = ({ width = 32, height = 32, className = "" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 32 32"
      className={className}
    >
      <g className="nc-icon-wrapper">
        <rect x="2" y="7" width="28" height="18" rx="3" ry="3" fill="#f79e1b" strokeWidth="0"></rect>
        <path d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z" strokeWidth="0" opacity=".15"></path>
        <path d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z" fill="#fff" opacity=".2" strokeWidth="0"></path>
        <circle cx="12" cy="16" r="6" fill="#eb001b" strokeWidth="0"></circle>
        <circle cx="20" cy="16" r="6" fill="#f79e1b" strokeWidth="0"></circle>
        <path d="m16,10c-3.314,0-6,2.686-6,6s2.686,6,6,6c1.657,0,3.157-.672,4.243-1.757.586-.586,1.071-1.243,1.414-1.943.343-.7.343-1.6,0-2.6-.343-1-.828-1.657-1.414-2.243C19.157,10.672,17.657,10,16,10Z" fill="#ff5f00" strokeWidth="0"></path>
      </g>
    </svg>
  );
};

export default Mastercard; 